import {
  addTenantAwsAccountResource,
  getTenantAwsAccountResource,
  removeTenantAwsAccountResource,
  updateTenantAwsAccountResource,
} from '../../services/api-calls';

import { AWS_ACCOUNT_ID_REGEX } from '../../../../global/constants';
import resourceConfigurationHoc from '../common/resourceConfigurationHoc';

const AwsAccount = resourceConfigurationHoc(
  'Aws Account',
  {
    uuid: {
      header: 'ID',
      type: 'text',
      width: 500,
    },
    awsAccountId: {
      header: 'Aws Account Id',
      type: 'editableInput',
      validationHandler: async input => {
        if (!AWS_ACCOUNT_ID_REGEX.test(input)) {
          throw Error(`cannot be empty and must be 12 digits`);
        }
      },
    },
    name: {
      header: 'Name',
      type: 'editableInput',
      validationHandler: async input => {
        if (!input) {
          throw Error(`cannot be empty`);
        }
      },
    },
    description: {
      header: 'Description',
      type: 'editableInput',
    },
  },
  addTenantAwsAccountResource,
  updateTenantAwsAccountResource,
  removeTenantAwsAccountResource,
  getTenantAwsAccountResource,
  false,
  false,
  false
);

export default AwsAccount;
